import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';
import {isApiResponseOk, normalize, normalizedDelete, normalizedUpdate} from '../../util/utils';

function mapAccount(account) {
	const mappedAccount = {...account};

	if (account.assertions) {
		mappedAccount.assertions = account?.assertions?.map((assertion) => assertion);
	}

	if (account.entities) {
		mappedAccount.entities = account?.entities?.map((entity) => entity.id);
	}

	return mappedAccount;
}

/**
 * Deletes an account from a normalized state.
 * @param {Object} state Normalized accounts state.
 * @param {number} accountId Account id.
 * @returns	{Object} Updated normalized accounts state.
 */
function deleteAccount(state, accountId) {
	return normalizedDelete(state, accountId);
}

const deleteAccountFromStore = (accountId, state) => {
	let newState = {...state};

	// Delete the account from both manageAccounts and root slices
	if (newState.manageAccounts) {
		newState.manageAccounts = deleteAccount(newState.manageAccounts, accountId);
	}

	newState = deleteAccount(newState, accountId);

	return newState;
};

export function manageAccountsReducer(state = initialstate.manageAccounts, action) {
	let newState;

	switch (action.type) {
		case types.GET_MANAGE_ACCOUNTS:
			if (action.response && action.response.data) {
				newState = {...state};

				const accountList = normalize(action.response.data.map((account) => mapAccount(account)));
				accountList.pages = action.response.pages;
				accountList.totalEntityCount = action.response.totalEntityCount;

				newState = {...accountList};

				return newState;
			}
			return state;
		case types.GET_MANAGE_ACCOUNT_BY_ID: {
			if (action.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteAccountFromStore(action.accountId, state);
			}
			if (isApiResponseOk(action)) {
				newState = {...state};
				const accountPayload = mapAccount(action.response);

				if (accountPayload?.entities === null) {
					accountPayload.entities = newState?.byId[action?.response?.id]?.entities;
				}
				newState = normalize([accountPayload], undefined, newState);

				return newState;
			}

			return state;
		}

		case types.CREATE_MANAGE_ACCOUNT: {
			if (isApiResponseOk(action)) {
				newState = state ? {...state} : normalize();

				const newAccount = mapAccount(action.response);

				newState = normalize([newAccount], undefined, newState);
				return newState;
			}
			return state;
		}

		case types.UPDATE_MANAGE_ACCOUNT:
			if (action.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteAccountFromStore(action.accountId, state);
			}
			if (isApiResponseOk(action)) {
				newState = {...state};
				// Update account in both manageAccount and root slices:
				const accountPayload = mapAccount(action.response);

				if (newState.manageAccounts) {
					newState.manageAccounts = normalizedUpdate(accountPayload.id, accountPayload, newState.manageAccounts);
				}

				newState = normalizedUpdate(accountPayload.id, accountPayload, newState);

				return newState;
			}

			return state;

		case types.DELETE_MANAGE_ACCOUNT: {
			if (isApiResponseOk(action) || action.error.response.status === HttpStatusCodes.NotFound) {
				return deleteAccountFromStore(action.accountId, state);
			}

			return state;
		}

		default:
			return state;
	}
}

export function manageAccountReducer(state = initialstate.manageAccount, action) {
	let newState;

	switch (action.type) {
		case types.DELETE_MANAGE_ACCOUNT: {
			if (isApiResponseOk(action) || action.error.response.status === HttpStatusCodes.NotFound) {
				newState = {...state};

				// Delete the account from both manageAccounts and root slices
				if (newState.manageAccounts) {
					newState.manageAccounts = deleteAccount(newState.manageAccounts, action.accountId);
				}

				newState = deleteAccount(newState, action.accountId);

				return newState;
			}

			return state;
		}
		case types.CREATE_MANAGE_ACCOUNT: {
			if (isApiResponseOk(action)) {
				const newAccount = mapAccount(action.response);
				return newAccount;
			}
			return state;
		}
		case types.UPDATE_MANAGE_ACCOUNT:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let account = _.cloneDeep(state);
				if (account.id === action.response.id) {
					account.accountTypeId = action.response.accountTypeId;
				}
				account = {...account, ...action.response};

				return account;
			}

			return state;
		case types.GET_MANAGE_ACCOUNT_BY_ID: {
			if (action.response) {
				return action.response || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		}
		case types.CLEAN_MANAGE_ACCOUNT:
			return {};
		default:
			return state;
	}
}
